import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WebPagesComponent } from './web-pages.component';
import { MaterialModuleWeb } from '../material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {DragDropModule} from '@angular/cdk/drag-drop';



@NgModule({
  declarations: [WebPagesComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModuleWeb,
    DragDropModule
  ],
  exports: [WebPagesComponent]
})
export class WebPagesModule { }
